/* tslint:disable */
/* eslint-disable */
/**
 * Mailbox API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const MailboxItemLinkType = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3
} as const;
export type MailboxItemLinkType = typeof MailboxItemLinkType[keyof typeof MailboxItemLinkType];


export function instanceOfMailboxItemLinkType(value: any): boolean {
    for (const key in MailboxItemLinkType) {
        if (Object.prototype.hasOwnProperty.call(MailboxItemLinkType, key)) {
            if (MailboxItemLinkType[key as keyof typeof MailboxItemLinkType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MailboxItemLinkTypeFromJSON(json: any): MailboxItemLinkType {
    return MailboxItemLinkTypeFromJSONTyped(json, false);
}

export function MailboxItemLinkTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MailboxItemLinkType {
    return json as MailboxItemLinkType;
}

export function MailboxItemLinkTypeToJSON(value?: MailboxItemLinkType | null): any {
    return value as any;
}

export function MailboxItemLinkTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): MailboxItemLinkType {
    return value as MailboxItemLinkType;
}

